import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminApiService } from 'app/services/admin-api.service';
import moment from 'moment';
import { ForestsService } from 'app/forests/services/forests.service';
import { ForestDto } from '@system-shared/classes.dto';

@Component({
    selector: 'app-admin-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.scss'],
    standalone: false
})
export class AdminUsersComponent implements OnInit {
  @HostListener('document:click', ['$event.target']) public onClick(target) {
    // show / close row menu
    if (
      typeof target.className === 'string' &&
      target.className.includes('edit-delete-button')
    ) {
      let rect = target.getBoundingClientRect();
      let menu = document.getElementsByClassName(
        'settings-menu'
      ) as HTMLCollectionOf<HTMLElement>;
      menu[0].style.top = rect.top + 'px';
    } else {
      this.showingRowMenu = false;
    }
  }
  showingRowMenu = false;
  users = []
  columns = [{
    label: 'Date Added',
    key: 'created'
  },
  {
    label: 'Last Name',
    key: 'lastName'
  },
  {
    label: 'First Name',
    key: 'firstName'
  },
  {
    label: 'Email Address',
    key: 'email',
    minWidth: '200px'
  },
  {
    label: 'Phone',
    key: 'phoneNumber'
  },
  {
    label: 'Status',
    key: 'status'
  }];

  regionOptions = [{
    label: 'All Regions',
    key: null
  }];
  regionFilter = this.regionOptions[0]
  forestOptions = [{
    label: 'All Forests',
    key: null,
    regionCode: null
  }];
  filteredForestOptions = [];
  forestFilter = this.forestOptions[0];
  tableSubtitle = '';

  isUpdated: boolean = false;
  updatedAction: string;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private adminApiService: AdminApiService,
    private forestsService: ForestsService) {
      this.route.queryParams.subscribe(params => {
        if (params['updated'] && ((Number(params['updated']) + 2000) > new Date().getTime())) {
          this.isUpdated = true;
          this.updatedAction = params['action'];
        }
      });
     }

  ngOnInit() {
    this.setTableSubtitle()
    this.getUsers();
    this.getForests();
  }

  getUsers = () => {
    this.adminApiService.getUsers(this.regionFilter.key, this.forestFilter.key).subscribe((data: any) => {
      this.users = data;
    });
  }

  getForests = () => {
    this.forestsService.getAllByAdmin().subscribe((forests: ForestDto[]) => {
      let adminForestOptions = forests.map((forest: ForestDto) => {
        return {
          label: forest.forestNameFormal,
          key: forest.code,
          regionCode: forest.regionCode
        };
      });
      // if they only have access to one forest then choose the one forest by default
      if (adminForestOptions && adminForestOptions.length === 1) {
        this.forestOptions = [...adminForestOptions];
        this.forestFilter = adminForestOptions[0];
      } else {
        this.forestOptions.push(...adminForestOptions);
      }
      this.filteredForestOptions = [...this.forestOptions];

      let adminRegionOptions = [];
      forests.forEach((forest: any) => {
        if (!adminRegionOptions.some((region: any) => region.key == forest.regionCode)) {
          adminRegionOptions.push({
            label: `${(+forest.regionCode)}`,
            key: forest.regionCode
          });
        }
      });
      adminRegionOptions.sort((a, b) => a.key.localeCompare(b.key));
      // if they only have access to one region then choose the one region by default
      if (adminForestOptions && adminForestOptions.length === 1) {
        this.regionOptions = [...adminRegionOptions];
        this.regionFilter = adminRegionOptions[0];
      } else {
        this.regionOptions.push(...adminRegionOptions);
      }
      this.regionOptions = [...this.regionOptions];
    });
  }

  filterByForest = (event) => {
    this.forestFilter = event
    this.setTableSubtitle();
    this.getUsers();
  }

  filterByRegion = (event) => {
    this.regionFilter = event
    this.forestFilter = this.forestOptions[0];
    this.setTableSubtitle();
    if (event.key === null) {
      this.filteredForestOptions = this.forestOptions;
    } else {
      this.filteredForestOptions = this.forestOptions.filter((forestOption: any) => forestOption.regionCode == null || forestOption.regionCode == this.regionFilter.key);
    }
    this.getUsers();
  }

  setTableSubtitle() {
    if (this.regionFilter.key === null && this.forestFilter.key === null) {
      this.tableSubtitle = 'All Regions - All Forests';
    } else if (this.regionFilter.key !== null && this.forestFilter.key === null) {
      this.tableSubtitle = `${this.regionFilter.label} - All Forests`;
    } else {
      this.tableSubtitle = `${this.regionFilter.label} - ${this.forestFilter.label}`;
    }
  }

  getCellData = (column, row) => {
    let displayValue = row[column.key];
    if (column.friendly) {
      displayValue = row[column.friendly];
    } else if (column.key === 'firstName' && ((row.firstName === '---') || (row.firstName === '') || (row.firstName === null))) {
      displayValue = 'Pending'
    } else if (column.key === 'lastName' && ((row.lastName === '---') || (row.lastName === '') || (row.lastName === null))) {
      displayValue = 'Pending'
    } else if (column.key === 'phoneNumber' && ((row.phoneNumber === null) || (row.phoneNumber === ''))) {
      displayValue = '- - -'
    }
    if (column.key === 'createdAt' || column.key === 'created') {
      displayValue = moment(row[column.key]).format('MM/DD/YYYY');
    }
    return displayValue;
  };

  addUser = () => {
    this.router.navigate(['/admin/users/add']);
  }

  showRowMenu = (row, index) => {
    this.showingRowMenu = index;
  };

  view = (row) => {
    this.router.navigate([`/admin/users/${row.id}`]);
  }

  edit = (row) => {
    this.router.navigate([`/admin/users/${row.id}/edit`]);
  }
}
